import { Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { HiPlus } from 'react-icons/hi';
import InventoryListTable from './InventoryListTable';
import { Inventory } from '../../Models/Inventory';
import { useAppSelector } from '../../Reducers/store';
import Loader from '../Common/Loader';
import InventoryApi from '../../Api/InventoryApi';
import InventoryModal from './InventoryModal';
import VendorApi from '../../Api/VendorApi';

export default function InventoryList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [inventoryListData, setinventoryListData] = useState<Inventory[]>([]);
  const [selectedInventory, setSelectedInventory] = useState<Inventory | null>(
    null
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const getInventory = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return InventoryApi.getInventoryList()
          .then((res) => {
            setinventoryListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getInventory();
  }, [getInventory]);

  const handleAddInventoryClick = () => {
    setSelectedInventory(null);
    setShowModal(true);
  };

  const editInventory = (inv: Inventory) => {
    setSelectedInventory(inv);
    setShowModal(true);
  };

  function deleteInventory(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      VendorApi.deleteInventory(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getInventory();
          } else {
            toast.error('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Inventory</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Button
                  onClick={handleAddInventoryClick}
                  className='buttonMain'
                >
                  <HiPlus size={20} />
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          <div className='relative'>
            {isLoading && <Loader />}
            <InventoryListTable
              data={inventoryListData}
              deleteInventory={deleteInventory}
              editInventory={editInventory}
            />
          </div>
        </div>
      </div>
      <InventoryModal
        show={showModal}
        setShow={setShowModal}
        getInventory={getInventory}
        selectedInventory={selectedInventory}
      />
    </>
  );
}
